import React from 'react';

import { ApplicationRoutes } from 'common/constants';
import { useHistory, useLocation } from 'react-router-dom';

import { Tab, Tabs } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import TopNav from './TopNav';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabRoot: {
      [theme.breakpoints.down('md')]: {
        minWidth: 130,
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 70,
      },
    },
  }),
);

interface ViewTab {
  name: string;
  icon: React.ReactElement;
  route: ApplicationRoutes | string;
  content: React.ReactNode;
  isDisabled?: boolean;
  protected: boolean;
  exact: boolean;
}

interface Props {
  tabs: ViewTab[];
}

const NavBar = ({ tabs }: Props) => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();

  // split removes the sub-routes
  let value = tabs.map((r) => r.route).indexOf(`/${location.pathname.split('/')[1]}`);

  if (value > tabs.length - 1 || value < 0) {
    value = 0;
  }

  return (
    <TopNav>
      <Tabs value={value} onChange={(_, newValue) => history.push(tabs[newValue].route)}>
        {tabs.map((tab, index) => (
          <Tab
            label={tab.name}
            icon={tab.icon}
            key={index}
            disabled={tab.isDisabled}
            className={classes.tabRoot}
          />
        ))}
      </Tabs>
    </TopNav>
  );
};

export default NavBar;
